import { Injectable, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
// import { AnyARecord } from 'dns';
// import { Password } from 'primeng/password';
import { environment } from '../../environments/environment'; 
@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {
  redirectUrl!: string;
     

// baseUrl:string = "http://myroots.redmindtechnologies.com/api/";                        
               // baseUrl:string = "https://redmindtechnologies.com/dmk_php-dhanasekar/";                         
            // baseUrl:string="http://localhost/myroots_api/Myroots_Backend_php/";
            // baseUrl:string="http://localhost/Myroots/backend/";
                 baseUrl:string= environment.baseUrl;

@Output() getLoggedInName: EventEmitter<any> = new EventEmitter();
  valueChanges: any;
  district: any;
constructor(private httpClient : HttpClient) {};


user_district:any='null';

public mydist = [
    {
        name:'Select District',
        value:''
    },
    {
      name: "Namakkal",
      value:'Namakkal'
    },
    {
      name: "Salem",
      value:"Salem"
    },
    {
      name: "Trichy",
      value:"Trichy",
    },
    {
      name: "Erode",
      value:"Erode"
    },
];

  public user_details: any = JSON.parse(localStorage.getItem('login_user_details'));
  public district_user: any =    localStorage.getItem('user_district');
   public constituency_user:any = localStorage.getItem('user_constituency');

public constituencies=[
  { name:'Select constituencies/தொகுதியைத் தேர்ந்தெடுக்கவும்'},{ name:'Salem (West)'}, { name:'Salem (North)'}, { name:'Salem (South)'}, { name:'Veerapandi'}, { name:'Rasipuram'},
  { name:'Senthamangalam'}, { name:'Attur'}, { name:'Yercaud'}, { name:'Namakkal'}, { name:'Rasipuram'},
  { name:'Erode (East)'}, { name:'Erode (West)'},

]
public districts=[
  { name:'Salem (West)'}, { name:'Salem (North)'}, { name:'Salem (South)'}, { name:'Veerapandi'}, { name:'Rasipuram'},
  { name:'Senthamangalam'}, { name:'Attur'}, { name:'Yercaud'}, { name:'Namakkal'}, { name:'Rasipuram'},
  { name:'Erode (East)'}, { name:'Erode (West)'},

]
// public all_districts=['Chennai North', 'Chennai North East', 'Chennai East', 'Chennai West', 'Chennai South West', 'Chennai South',
// 'Thiruvallur East', 'Thiruvallur Central', 'Thiruvallur West', 'Kanchipuram North', 'Kanchipuram South', 'Ranipet', 'Vellore',
// 'Tirupattur', 'Tiruvannamalai North', 'Tiruvannamalai South', 'Villupuram North', 'Villupuram South', 'Kallakurichi North', 'Kallakurichi South',
// 'Cuddalore East', 'Cuddalore West', 'Thanjavur North', 'Thanjavur Central', 'Thanjavur South', 'Mayiladuthurai', 'Nagai', 'Tiruvarur',
// 'Trichy North', 'Trichy Central', 'Trichy South', 'Perambalur','Pondicherry', 'Ariyalur', 'Karur','Karaikal', 'Pudukottai North', 'Pudukottai South', 'Salem East',
// 'Salem West', 'Salem Central', 'Namakkal East', 'Namakkal West', 'Dharmapuri East', 'Dharmapuri West', 'Krishnagiri East', 'Krishnagiri West', 'Coimbatore North',
// 'Coimbatore South','Coimbatore Manager','Tirupur North','Tirupur South','Erode North','Erode South','Nilgiri','Madurai North','Madurai South','Madurai Manager','Dindigul East',
// 'Dindigul West','Theni North','Theni South',
// 'Ramanathapuram', 'Sivagangai', 'Virudhunagar North', 'Virudhunagar South', 'Tirunelveli East', 'Tirunelveli Central','Tenkasi North',
// 'Tenkasi South','Thoothukudi North','Thoothukudi South','Kanniyakumari East','Kanniyakumari West'];

public all_districts = ['Select District',
  //'Aarani',
 'Ariyalur', 'Karur', 
 //'Nagappattinam', 
 'Perambalur', 'Pudukkottai', 
'Thanjavur', 'Tiruvarur', 'Mayiladuthurai', 'Dharmapuri', 'Coimbatore', 
'Erode', 'Krishnagiri', 'Namakkal', 'Nilgiris', 'Salem', 'Tiruppur', 
'Dindigul', 'Kanyakumari', 'Madurai', 'Ramanathapuram', 'Sivagangai', 'Theni', 
'Thoothukudi', 'Tirunelveli', 'Virudhunagar', 'Tenkasi', 'Chennai', 'Cuddalore', 
'Kanchipuram',
 //'Chengalpattu',
  'Tiruvallur', 'Tiruvannamalai', 'Vellore', 
'Viluppuram', 'Kallakurichi', 'Ranipet', 'Thirupattur','Trichy']

public country=[ 'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia',
  'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium',
  'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad',
  'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji',
  'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea',
  'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq',
  'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati',
  'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania',
  'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania',
  'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique',
  'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea',
  'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
  'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal',
  'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia',
  'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
  'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States',
  'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];


public all_municipals=['Avadi City', 'Tambaram city', 'Kanchipuram city', 'Vellore city', 'Cuddalore city', 'Kumbakonam city',
'Thanjavur City', 'Trichy East City', 'Trichy West City', 'Karur city', 'Salem city', 'Hosur city', 'Tirupur North City',
'Tirupur south City', 'Erode city', 'Dindigul City', 'Sivakasi City', 'Thoothukudi city', 'Tirunelveli City', 'Nagercoil City'];

public meeting_districts=['Chennai North', 'Chennai North East', 'Chennai East', 'Chennai West', 'Chennai South West', 'Chennai South',
'Thiruvallur East', 'Thiruvallur Central', 'Thiruvallur West', 'Kanchipuram North', 'Kanchipuram South', 'Ranipet', 'Vellore',
'Tirupattur', 'Tiruvannamalai North', 'Tiruvannamalai South', 'Villupuram North', 'Villupuram South', 'Kallakurichi North', 'Kallakurichi South',
'Cuddalore East', 'Cuddalore West', 'Thanjavur North', 'Thanjavur Central', 'Thanjavur South', 'Mayiladuthurai', 'Nagai', 'Tiruvarur',
'Trichy North', 'Trichy Central', 'Trichy South', 'Perambalur', 'Ariyalur', 'Karur', 'Pudukottai North', 'Pudukottai South', 'Salem East',
'Salem West', 'Salem Central', 'Namakkal East', 'Namakkal West', 'Dharmapuri East', 'Dharmapuri West', 'Krishnagiri East', 'Krishnagiri West', 'Coimbatore North',
'Coimbatore South','Coimbatore Manager','Tirupur North','Tirupur South','Erode North','Erode South','Nilgiri','Madurai North','Madurai South','Madurai Manager','Dindigul East',
'Dindigul West','Theni North','Theni South',
'Ramanathapuram', 'Sivagangai', 'Virudhunagar North', 'Virudhunagar South', 'Tirunelveli East', 'Tirunelveli Central','Tenkasi North',
'Tenkasi South','Thoothukudi North','Thoothukudi South','Kanniyakumari East','Kanniyakumari West'];

// public all_constituency={ 'Chennai North': ['Dr. Radhakrishnan Nagar', 'Perambur', 'Royapuram'],
// 'Chennai North East': ['Madhavaram', 'Tiruvottiyur'],
// 'Chennai East': ['Ambattur', 'Kolathur', 'Villivakam', 'Thiru.Vi.Ka Nagar (R)', 'Egmore (R)', 'Harbour'],
// 'Chennai West': ['Chepauk-Thiruvallikeni', 'Thousand Lights', 'Anna Nagar'],
// 'Chennai South West': ['Thiyagarayanagar', 'Mylapore'],
// 'Chennai South': ['Maduravoyal', 'Virugambakkam', 'Saidapet', 'Velachery', 'Sholinganallur'],
// 'Thiruvallur East': ['Gummidipoondi', 'Ponneri (R)'],
// 'Thiruvallur Central': ['Poonamallee (R)', 'Avadi'],
// 'Thiruvallur West': ['Tiruttani', 'Thiruvallur'],
// 'Kanchipuram North': ['Alandur', 'Sriperumbudur (R)', 'Pallavaram', 'Tambaram', 'Chengalpattu', 'Thiruporur'],
// 'Kanchipuram South': ['cheyyur (R)', 'Maduranthakam (R)', 'Uthiramerur', 'Kanchipuram'],
// 'Ranipet': ['Arakkonam (R)', 'Sholingur', 'Ranipet', 'Arcot'],
// 'Vellore': ['Katpadi', 'Vellore', 'Anaikattu', 'Kilvaithinankuppam (R)', 'Gudiyatham (R)'],
// 'Tirupattur': ['Vaniyambadi', 'Ambur', 'Jolarpettai', 'Tirupattur'],
// 'Tiruvannamalai North': ['Polur', 'Arani', 'Cheyyar', 'Vandavasi (R)'],
// 'Tiruvannamalai South': ['Chengam (R)', 'Thiruvannamalai', 'Kilpennathur', 'Kalasapakkam'],
// 'Villupuram North': ['Gingee', 'Mayilam', 'Tindivanam (R)'],
// 'Villupuram South': ['Vanur (R)', 'Villupuram', 'Vikravandi', 'Thirukoilur'],
// 'Kallakurichi North': ['Ulundurpet', 'Shankarapuram'],
// 'Kallakurichi South': ['Rishivandiyam', 'Kallakurichi (R)'],
// 'Cuddalore East': ['Cuddalore', 'Kurinjipadi', 'Bhuvanagiri', 'Chidambaram', 'Kattumannarkoil (R)'],
// 'Cuddalore West': ['Tittakudi (R)', 'Virudhachalam', 'Neyveli', 'Panruti'],
// 'Thanjavur North': ['Thiruvidaimarudur (R)', 'Kumbakonam', 'Papanasam'],
// 'Thanjavur Central': ['Thiruvaiyaru', 'Thanjavur', 'Orathanadu'],
// 'Thanjavur South': ['Pattukkottai', 'Peravurani'],
// 'Mayiladuthurai': ['Sirkazhi (R)', 'Mayiladuthurai', 'Poompuhar'],
// 'Nagai': ['Nagapattinam', 'Kilvelur (R)', 'Vedaranyam'],
// 'Tiruvarur': ['Thiruthuraipoondi (R)', 'Mannargudi', 'Thiruvarur', 'Nannilam'],
// 'Trichy North': ['Manchanallur', 'Musiri', 'Thuraiyur (R)'],
// 'Trichy Central': ['Thiruvarangam', 'Tiruchirappalli West', 'Lalgudi'],
// 'Trichy South': ['Manapparai', 'Tiruchirappalli East', 'Thiruverumbur'],
// 'Perambalur': ['Perambalur (R)', 'Kunnam'],
// 'Pondicherry': ['Mannadipet', 'Thirubhuvanai','Ossudu','Mangalam','Vilianur','Ozhukarai','Kathirkamam','Indira Nagar','Thattanchavady','Kamaraj Nagar','Lawspet','Kalapet','Muthialpet','Raj Bhavan','Oupalam','Orleampeth','Nellithope','Mudaliarpet','Ariankuppam','Manavely','Embalam','Nettapakkam','Bahour'],
// 'Ariyalur': ['Ariyalur', 'Jayankondam'],
// 'Karur': ['Aravakurichi', 'Karur', 'Krishnarayapuram (R)', 'Kulithalai'],
// 'Karaikal':['Nedungadu','Thirunallar','Karaikal North','Karaikal South','Neravy T.R.Pattinam'],
// 'Pudukottai North': ['Gandarvakottai (R)', 'Viralimalai', 'Pudukottai'],
// 'Pudukottai South': ['Thirumayam', 'Alangudi', 'Aranthangi'],
// 'Salem East': ['Gangavalli (R)', 'Attur', 'Yercaud (Tribe)', 'Veerapandi'],
// 'Salem West': ['Mettur', 'Edappadi', 'Sankagiri'],
// 'Salem Central': ['Omalur', 'Salem West', 'Salem North', 'Salem South'],
// 'Namakkal East': ['Rasipuram (R)', 'Senthamangalam (Tribe)', 'Namakkal'],
// 'Namakkal West': ['Paramathi-Velur', 'Tiruchengode', 'Kumarapalayam'],
// 'Dharmapuri East': ['Dharmapuri', 'Pennagaram'],
// 'Dharmapuri West': ['Palacode', 'Pappireddipatti', 'Harur (R)'],
// 'Krishnagiri East': ['Uthangarai (R)', 'Bargur', 'Krishnagiri'],
// 'Krishnagiri West': ['Veppanahalli', 'Hosur', 'Thalli'],
// 'Coimbatore North': ['Mettupalayam', 'Thondamuthur', 'Kavundampalayam', 'Avinashi (R)'],
// 'Coimbatore South':['Sulur','Kinathukadavu','Pollachi','Valparai (R)'],
// 'Coimbatore Manager': ['Coimbatore North', 'Coimbatore South', 'Singanallur'],
//  'Tirupur North': ['Tirupur North', 'Tirupur South','Palladam'],
//   'Tirupur South': ['Dharapuram (R)', 'Kangayam', 'Udumalaipettai','Madathukulam'],
//  'Erode North': ['Bhavani', 'Anthiyur', 'Gobichettipalayam','Bhavani Sagar (R)'],
//  'Erode South': ['Erode East', 'Erode West','Modakkurichi','Perundurai'],
//  'Nilgiri':['Udhagamandalam','gudalur (R)','Coonoor'],
//   'Madurai North': ['Melur', 'Madurai East', 'Sholavandan (R)'],
//   'Madurai South': ['Tirumangalam', 'Thiruparankundram','Usilampatti'],
//   'Madurai Manager': ['Madurai North','Madurai South','Madurai Central','Madurai West'],
// 'Dindigul East': ['Palani', 'Athoor','Nilakkottai (R)','Dindigul'],
//   'Dindigul West': ['Oddanchatram', 'Natham','Vedasandur'],
// 'Theni North': ['Periyakulam (R)', 'Bodinayakanur'],
//  'Theni South': ['Andipatti','Cumbum'],
// 'Ramanathapuram': ['Paramakudi (R)', ' Tiruvadanai', 'Ramanathapuram', 'Mudukulathur'],
// 'Sivagangai': ['Karaikudi', 'Tiruppattur', 'Sivagangai', 'Manamadurai (R)'],
// 'Virudhunagar North': ['Sivakasi', 'Virudhunagar', 'Tiruchuli'],
// 'Virudhunagar South': ['Rajapalayam', 'Srivilliputhur (R)', 'Sattur', 'Aruppukkottai'],
// 'Tirunelveli East': ['Ambasamudram', 'Nanguneri', 'Radhapuram'],
// 'Tirunelveli Central': ['Tirunelveli', 'Palayamkottai'],
// 'Tenkasi North':['Vasudevanallur (R)','Sankaran Kovil (R)'],
// 'Tenkasi South': ['Kadayanallur', 'Tenkasi', 'Alangulam'],
// 'Thoothukudi North': ['Vilathikulam', 'Thoothukkudi','Kovilpatti'],
//  'Thoothukudi South': ['Tiruchendur', 'Srivaikuntam', 'Ottapidaram (R)'],
//  'Kanniyakumari East': ['Kanniyakumari', 'Nagercoil', 'Colachel'],
//  'Kanniyakumari West': ['Padmanabhapuram', 'Vilavancode ','Killiyoor'],

// };

public all_constituency = {
  
  'Trichy': ['Manchanallur', 'Musiri', 'Thuraiyur (R)', 'Thiruvarangam', 'Tiruchirappalli West', 'Lalgudi', 'Manapparai', 'Tiruchirappalli East', 'Thiruverumbur'],

 // 'Aarani': [],
  'Ariyalur': ['Ariyalur', 'Jayankondam'],
  'Karur': ['Aravakurichi', 'Karur', 'Krishnarayapuram (R)', 'Kulithalai'],
 // 'Nagappattinam': [],
  'Perambalur': ['Perambalur (R)', 'Kunnam'],
  'Pudukkottai': ['Gandarvakottai (R)', 'Viralimalai', 'Pudukottai'],
  'Thanjavur': ['Thiruvidaimarudur (R)', 'Kumbakonam', 'Papanasam', 'Thiruvaiyaru', 'Thanjavur', 'Orathanadu'],
  'Tiruvarur': ['Thiruthuraipoondi (R)', 'Mannargudi', 'Thiruvarur', 'Nannilam'],
  'Mayiladuthurai': ['Sirkazhi (R)', 'Mayiladuthurai', 'Poompuhar'],
  'Dharmapuri': ['Dharmapuri', 'Pennagaram', 'Palacode', 'Pappireddipatti', 'Harur (R)'],
  'Coimbatore': ['Mettupalayam', 'Thondamuthur', 'Kavundampalayam', 'Avinashi (R)', 'Sulur', 'Kinathukadavu', 'Pollachi', 'Valparai (R)', 'Singanallur'],
  'Erode': ['Bhavani', 'Anthiyur', 'Gobichettipalayam', 'Bhavani Sagar (R)', 'Erode East', 'Erode West', 'Modakkurichi', 'Perundurai'],
  'Krishnagiri': ['Uthangarai (R)', 'Bargur', 'Krishnagiri', 'Veppanahalli', 'Hosur', 'Thalli'],
  'Namakkal': ['Rasipuram (R)', 'Senthamangalam (Tribe)', 'Namakkal', 'Paramathi-Velur', 'Tiruchengode', 'Kumarapalayam'],
  'The Nilgiris': ['Udhagamandalam', 'Gudalur (R)', 'Coonoor'],
  'Salem': ['Gangavalli (R)', 'Attur', 'Yercaud (Tribe)', 'Veerapandi', 'Mettur', 'Edappadi', 'Sankagiri', 'Omalur', 'Salem West', 'Salem North', 'Salem South'],
  'Tiruppur': ['Tirupur North', 'Tirupur South', 'Palladam', 'Dharapuram (R)', 'Kangayam', 'Udumalaipettai', 'Madathukulam'],
  'Dindigul': ['Palani', 'Athoor', 'Nilakkottai (R)', 'Dindigul', 'Oddanchatram', 'Natham', 'Vedasandur'],
  'Kanyakumari': ['Nagercoil', 'Colachel', 'Padmanabhapuram', 'Vilavancode', 'Killiyoor'],
  'Madurai': ['Melur', 'Madurai East', 'Sholavandan (R)', 'Tirumangalam', 'Thiruparankundram', 'Usilampatti', 'Madurai Central', 'Madurai West'],
  'Ramanathapuram': ['Paramakudi (R)', 'Tiruvadanai', 'Ramanathapuram', 'Mudukulathur'],
  'Sivagangai': ['Karaikudi', 'Tiruppattur', 'Sivagangai', 'Manamadurai (R)'],
  'Theni': ['Periyakulam (R)', 'Bodinayakanur', 'Andipatti', 'Cumbum'],
  'Thoothukudi': ['Vilathikulam', 'Thoothukkudi', 'Kovilpatti', 'Tiruchendur', 'Srivaikuntam', 'Ottapidaram (R)'],
  'Tirunelveli': ['Ambasamudram', 'Nanguneri', 'Radhapuram', 'Tirunelveli', 'Palayamkottai'],
  'Virudhunagar': ['Sivakasi', 'Virudhunagar', 'Tiruchuli', 'Rajapalayam', 'Srivilliputhur (R)', 'Sattur', 'Aruppukkottai'],
  'Tenkasi': ['Vasudevanallur (R)', 'Sankaran Kovil (R)', 'Kadayanallur', 'Tenkasi', 'Alangulam'],
  'Chennai': ['Dr. Radhakrishnan Nagar', 'Perambur', 'Royapuram', 'Madhavaram', 'Tiruvottiyur', 'Ambattur', 'Kolathur', 'Villivakam', 'Thiru.Vi.Ka Nagar (R)', 'Egmore (R)', 'Harbour', 'Chepauk-Thiruvallikeni', 'Thousand Lights', 'Anna Nagar', 'Thiyagarayanagar', 'Mylapore', 'Maduravoyal', 'Virugambakkam', 'Saidapet', 'Velachery', 'Sholinganallur'],
  'Cuddalore': ['Cuddalore', 'Kurinjipadi', 'Bhuvanagiri', 'Chidambaram', 'Kattumannarkoil (R)', 'Tittakudi (R)', 'Virudhachalam', 'Neyveli', 'Panruti'],
  'Kanchipuram': ['Alandur', 'Sriperumbudur (R)', 'Pallavaram', 'Tambaram', 'Chengalpattu', 'Thiruporur', 'cheyyur (R)', 'Maduranthakam (R)', 'Uthiramerur', 'Kanchipuram'],
  //'Chengalpattu': [],
  'Tiruvallur': ['Gummidipoondi', 'Ponneri (R)', 'Poonamallee (R)', 'Avadi', 'Tiruttani', 'Thiruvallur'],
  'Tiruvannamalai': ['Polur', 'Arani', 'Cheyyar', 'Vandavasi (R)', 'Chengam (R)', 'Thiruvannamalai', 'Kilpennathur', 'Kalasapakkam'],
  'Vellore': ['Katpadi', 'Vellore', 'Anaikattu', 'Kilvaithinankuppam (R)', 'Gudiyatham (R)', 'Vanur (R)', 'Villupuram', 'Vikravandi', 'Thirukoilur'],
  'Viluppuram': ['Gingee', 'Mayilam', 'Tindivanam (R)', 'Vanur (R)', 'Villupuram', 'Vikravandi', 'Thirukoilur'],
  'Kallakurichi': ['Ulundurpet', 'Shankarapuram', 'Rishivandiyam', 'Kallakurichi (R)'],
  'Ranipet': ['Arakkonam (R)', 'Sholingur', 'Ranipet', 'Arcot'],
  'Thirupattur': ['Vaniyambadi', 'Ambur', 'Jolarpettai', 'Tirupattur']
}


  public all_districts_zone = ['Chennai zone', 'Thanjavur zone', 'Cuddalore zone', 'Tiruvannamalai zone', 'Salem zone', 'Coimbatore zone', 'Madurai zone', 'Nellai zone', 'Trichy zone'];
  public zones_all = {
    'Chennai zone': ['Chennai North', 'Chennai South', 'Chennai North East', 'Chennai South West', 'Chennai West', 'Thiruvallur East', 'Thiruvallur West', 'Thiruvallur Central', 'Kanchipuram South', 'Kanchipuram West'],
    'Thanjavur zone': ['Thanjavur North', 'Thanjavur South', 'Thanjavur Central', 'Nagai', 'Tiruvarur', 'Karaikal'],
    'Cuddalore zone': ['Cuddalore East', 'Cuddalore West', 'Mayiladuthurai', 'Villupuram North', 'Villupuram South', 'Pondicherry'],
    'Tiruvannamalai zone': ['Tiruvannamalai North', 'Tiruvannamalai South','Ranipet','Vellore','Kallakurichi North', 'Kallakurichi South','Tirupattur'],
    'Salem zone': ['Salem East', 'Salem West', 'Salem Central', 'Namakkal East', 'Namakkal West', 'Dharmapuri East', 'Dharmapuri West', 'Krishnagiri East', 'Krishnagiri West'],
    'Coimbatore zone': ['Tirupur North', 'Tirupur South', 'Erode North', 'Erode South', 'Coimbatore North', 'Coimbatore South', 'Coimbatore Manager', 'Karur', 'Nilgiri'],
    'Madurai zone': ['Madurai North', 'Madurai South', 'Madurai Manager', 'Dindigul East', 'Dindigul West', 'Theni North', 'Theni South', 'Ramanathapuram', 'Sivagangai', 'Virudhunagar North', 'Virudhunagar South', 'Chennai East'],
    'Trichy zone': ['Trichy North', 'Trichy Central', 'Trichy South', 'Perambalur', 'Ariyalur', 'Pudukottai North', 'Pudukottai South'],
    'Nellai zone': ['Tirunelveli East', 'Tenkasi North', 'Thoothukudi South', 'Kanniyakumari East'],

  }
public all_designation=['Select designation ','District President / மாவட்ட தலைவர்','District Vice President / மாவட்ட துணை தலைவர்','District Organiser / மாவட்ட அமைப்பாளர்','District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்','Union Organiser / ஒன்றிய அமைப்பாளர்','Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்','City Organiser / நகர அமைப்பாளர்','City Deputy Organiser / நகர துணை அமைப்பாளர்','Area Organiser / பகுதி அமைப்பாளர்','Area Deputy Organiser / பகுதி துணை அமைப்பாளர்','illage Organiser / ஊரக அமைப்பாளர்','Village Deputy Organiser / ஊரக துணை அமைப்பாளர்'];
public catagory=['மாவட்டம்','மாநகரம்','ஒன்றியம்','நகரம்','பகுதி','பேரூர்'];

  public zones = [
    'Chennai',
    'Thanjavur',
    'Cuddalore',
    'Tiruvannamalai',
    'Coimbatore',
    'Madurai',
    'Trichy',
    'Nellai'
]


public all_profes=['Engineer',
'Architect',
'Lawyer',
'Accountant',
'Software Engineer',
'Chef',
'Graphic Designer',
'Salesperson',
'Business',
'Farmer' ,
'Weaver',
'Self employee',
'Professor/teacher'];

public constituency:any='No-Select';
checktoken:any[]=[]
public check_token(email:string) {
          return this.httpClient.get(this.baseUrl+"/check_token.php?email="+email);
                       }

userlogincheck:any[]=[];
public logincheck(whatapp) {
  return this.httpClient.get(this.baseUrl +'/loginusercheck.php?whatapp='+whatapp);
  }

  // student Login
  public studentCheck(whatapp) {
    return this.httpClient.get(this.baseUrl + '/loginStudentCheck.php?whatapp='+whatapp)
  }

  // Mentor Login
  public MentorCheck(whatapp) {
    return this.httpClient.get(this.baseUrl + '/loginMentorCheck.php?whatapp='+whatapp)
  }

public locked(whatsapp_no:any) {
  return this.httpClient.post(this.baseUrl +'/lock.php',{whatsapp_no})
  .pipe(map(Users => {
    return Users;
    }));
  }

  // Student Dashboard data
  public getStudentDashboardData() {
    return this.httpClient.get(this.baseUrl + '/count_student_data.php');
  }

  // Student Password Change

  public updatePassword(values:any,id:any) {
     return this.httpClient.post(this.baseUrl + `/student_password_change.php?id=${id}`, values);
  }

    public updatePasswordMentor(values:any,id:any) {
     return this.httpClient.post(this.baseUrl + `/mentor_password_change.php?id=${id}`, values);
  }

  // Student Course List

  public getStudentCourseList(district:any,student_id:any) {
    return this.httpClient.get(this.baseUrl + `/student_course_list.php?district=${district}&student_id=${student_id}`);
  }

  public StudentErollCourse(course_id: any, course_occ: any, student_id: any,permanent_token:any) {
    return this.httpClient.get(this.baseUrl + `/course_registeration.php?course_id=${course_id}&course_occ=${course_occ}&student_id=${student_id}&permanent_token=${permanent_token}`);
  }

   public StudentUnErollCourse(course_id: any, course_occ: any, student_id: any) {
    return this.httpClient.get(this.baseUrl + `/course_not_registeration.php?course_id=${course_id}&course_occ=${course_occ}&student_id=${student_id}`);
  }

  public StudentEnrolledCourse(student_id: any,district:any) {
    return this.httpClient.get(this.baseUrl + `/student_course_enroll.php?student_id=${student_id}&district=${district}`);
  }
  public StudentCourseEntroll(student_id: any,district:any) {
    return this.httpClient.get(this.baseUrl + `/student_enrolled_course.php?student_id=${student_id}`);
  }

  //student request 
  // public saveRequestedCourse(data: any){
  //   return this.httpClient.post(this.baseUrl + `/get_student_request.php`,data);
  // }
  public getCourseRequests(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_student_request.php`);
  }
  public getCourseGroupRequests(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/group_course_request.php`);
  }
  public saveGroupRequestedCourse(data:any){
    return this.httpClient.post(this.baseUrl + `/group_course_request.php`,data);
  }
  public getStudentRequestCourse(user_id: any,permanent_token:any): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/request_course.php?user_id=${user_id}&token=${permanent_token}`);
  }
  public getStudentgroupRequestCourse(user_id: any,permanent_token:any): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/group_course_request.php?user_id=${user_id}&token=${permanent_token}`);
  }
  
  // Course List
    public CourseStudentEnrolled(course_id: any) {
    return this.httpClient.get(this.baseUrl + `/get_students_for_course.php?id=${course_id}`);
  }

    public CourseAttendance(values:any) {
    return this.httpClient.post(this.baseUrl + `/create_student_attendance.php`, values);
  }


    public SuperCourseAttendance() {
    return this.httpClient.get(this.baseUrl + `/get_course_attendance.php`);
  }


public getGlobalChart() {
  return this.httpClient.get(this.baseUrl + '/get_ob_data.php');
  }


  // Student Graph
  public getStudentGraphStudent(course_id:any) {
    return this.httpClient.get(this.baseUrl + `/get_student_summary.php?id=${course_id}`)
  }

 // Mentor Graph 
  public getMentorGraph(course_id:any) {
    return this.httpClient.get(this.baseUrl + `/get_mentor_summary.php?id=${course_id}`)
  }

  public getStudentStar(student_id:any,course_id:any) {
    return this.httpClient.get(this.baseUrl + `/student_star.php?id=${student_id}&course_id=${course_id}`)
  } 

 public getGlobalEnigneer() {
  return this.httpClient.get(this.baseUrl + '/get_engineer_details.php');
 }

    public getStubbornChart() {
    return this.httpClient.get(this.baseUrl + '/get_stubborn_chart.php');
    }

    public getDonutChart() {
    return this.httpClient.get(this.baseUrl + '/get_donutchart.php');
   }
  public getGlobalEnigneer1() {
  return this.httpClient.get(this.baseUrl + '/get_engineer_details.php');
  }
  public getGlobalEnigneer2() {
  return this.httpClient.get(this.baseUrl + '/get_engineer_details.php');
}

  public create_activity(anyform: any)  {
   return  this.httpClient.post(this.baseUrl + '/create_activity.php', anyform);

  }

  public count_district_count(u_district:any,u_constituency:any) {
    return this.httpClient.get(this.baseUrl + `/count_activity_tasks.php?district=${u_district}&constituency=${u_constituency}`);
  }
table_report_da:any[] = [];
public report_da(){
  return this.httpClient.get(this.baseUrl + '/da-report.php?mode=1');
}
public userlogin(username : any, password :any, login_type:any = null,captcha:any) {
  console.log(login_type,"chjdks")
  return this.httpClient.post<any>(this.baseUrl + '/login.php', { username, password,login_type ,captcha}) 
   .pipe(map(Users => {
    console.log(Users, "checking");


    this.user_district= Users.data[0].district;
    this.constituency= Users.data[0].constituency;
    localStorage.setItem('user_district', JSON.stringify(Users.data[0].district));
    localStorage.setItem('user_constituency', JSON.stringify(Users.data[0].constituency));
    localStorage.setItem('login_user_details', JSON.stringify(Users.data[0]));
    localStorage.setItem('permanent_token', JSON.stringify(Users.data[0].permanent_token));
    this.user_details = Users.data[0];
    console.log(this.user_district)
    this.district=this.user_district;

  this.setToken(Users.data[0].name);
  this.getLoggedInName.emit(true);
  //only authorized user to login
  if(Users!=''){
    console.log(window.localStorage.getItem('UserToken'));
    sessionStorage.setItem('validUserToken', 'true');
  }
  return Users.data;
  }));
  }

public userregistration(datafull:FormData) {
  datafull.forEach((value,key) => {

    console.log(key+" "+value)

  });
  const params = new HttpParams();

        const options = {
            params,
            reportProgress: true,
        };

return this.httpClient.post(this.baseUrl + '/register.php',datafull,options)
}
public create_state_admin(mode:any,email:any,firstname:any,lastname:any,whatsapp_no:any,party_designation:any,approval_status:any,location_id:any,contact_no:any) {
  const httpOptions : Object = {
          headers: new HttpHeaders({
            'Content-Type':'application/x-www-form-urlencoded'
          })
        };
  return this.httpClient.post<any>(this.baseUrl + '/create.php?category=SA', { mode,email,firstname,lastname,whatsapp_no,party_designation,approval_status,location_id,contact_no },httpOptions )
  .pipe(map(Users => {
  return Users;
  }))
  }

    public create_dist_admin(mode:any,whatsapp_no:any,email:any,firstname:any,lastname:any,district:any,party_designation:any,approval_status:any,location_id:any,contact_no:any,fb_id:any,twitter_id:any) {
      const httpOptions : Object = {
        headers: new HttpHeaders({
          'Content-Type':'application/x-www-form-urlencoded'
        })
      };
      return this.httpClient.post<any>(this.baseUrl + '/create.php?category=DA', {mode, whatsapp_no,email,firstname,lastname,district,party_designation,approval_status,location_id,contact_no,fb_id,twitter_id },httpOptions )
        .pipe(map(Users => {
        return Users;
        }));
        }

          public create_office_bearers(datafull:FormData) {
            const httpOptions : Object = {
              headers: new HttpHeaders({
                'Content-Type':'application/x-www-form-urlencoded'
              })
            };

          const params = new HttpParams();

          const options = {
                params,
                reportProgress: true,
            };

            datafull.forEach((value,key) => {
              console.log(key+" "+value)
              });

            return this.httpClient.post<any>(this.baseUrl + '/create.php?category=OB',datafull,options)
            .pipe(map(Users => {
            return Users;
            }));
            }

            public delete_admin(user_id:any) {
              const httpOptions : Object = {
                headers: new HttpHeaders({
                  'Content-Type':'application/x-www-form-urlencoded'
                })
              };
                return this.httpClient.post<any>(this.baseUrl + '/delete.php', { user_id},httpOptions)
                .pipe(map(Users => {
                return Users;
                }));
                }

                public getChartDetails(name: any) {
                  const url = this.baseUrl + '/get_chart_details.php';
                    const httpOptions : Object = {
                              headers: new HttpHeaders({
                                'Content-Type':'application/json'
                              })
                            };
                            return this.httpClient.post<any>(url, { district: name }, httpOptions);
                              }

tabledata:any[]=[]
public viewtableSA() {
          return this.httpClient.get(this.baseUrl+'/show.php?mode=0');
                       }

tabledataDA:any[]=[];
public viewtableDA() {
          return this.httpClient.get(this.baseUrl + '/show.php?mode=1');

    }


                  tabledataOB:any[]=[];
                      public viewtableOB() {
                      return this.httpClient.get(this.baseUrl +'/show.php?mode=2');
                    }

               tabledataOBapprove:any[]=[];
                public viewtableOBapprove() {
                return this.httpClient.get(this.baseUrl +'/rolechange_approvel_show.php');
            }
            email_checking:any[]=[];
            public email_check() {
            return this.httpClient.get(this.baseUrl +'/email.php');
        }
        public email_check_student(a) {
          return this.httpClient.get(this.baseUrl +'/email.php?email='+a);
      }
        email_phone:any[]=[];
        public ph_check() {
        return this.httpClient.get(this.baseUrl +'/phone.php');
    }

    public student_ph_check() {
      return this.httpClient.get(this.baseUrl +'/student_phone.php');
  }
  public mentor_ph_check(phone) {
    return this.httpClient.get(this.baseUrl +'mentor_phone.php?phone='+phone);
}



            piechartdatasa:any[]=[];
            public piedatasa() {
              return this.httpClient.get(this.baseUrl +'/dashboardsapie.php');
            }
            cardsa:any[]=[];
            public carddatasa() {
              return this.httpClient.get(this.baseUrl +'/dashboardsacard.php');
            }

            barchartdatasa:any[]=[];
            public chartdatasa() {
              return this.httpClient.get(this.baseUrl +'/dashboardsabar.php');
            }
            tableda:any[]=[];
            public datablelogin(dadistrict:any) {
              return this.httpClient.post(this.baseUrl +'/dashow.php',{dadistrict})
              .pipe(map(Users => {
                return Users;
                }));

              }

              public roledatablelogin(dadistrict:any) {
     
                return this.httpClient.post(this.baseUrl +'/rolechange_req.php',{dadistrict})
                .pipe(map(Users => {
                  return Users;
                  }));
              }

            piechartdatada:any[]=[];
            logindistrict:any;
            public piedatada(ldistrict:any) {
               console.log('str');

               console.log(ldistrict);

              return this.httpClient.post<any>(this.baseUrl +'/dashboarddamonth.php',{ldistrict})
              .pipe(map(Users => {
                return Users;
                }));
            }

            barchartdatada:any[]=[];
            public chartdatada(barchart:any) {

               console.log(barchart);
                return this.httpClient.post(this.baseUrl +'/dashboardda.php',{barchart})
              .pipe(map(Users => {
                return Users;
                }));
            }
            dashboardcarddata:any[]=[];
            public dashboardcardda(cardistrict:any) {
               console.log(cardistrict);
              return this.httpClient.post(this.baseUrl +'/dashboarddacard.php',{cardistrict})
              .pipe(map(Users => {
                return Users;
                }));
            }
          public sendmail(email:any) {
            return this.httpClient.post<any>(this.baseUrl + 'send_email.php', { email })
            .pipe(map(Users => {
            return Users;
            }));
            }
            public resetpassword(email:any,password:any,cpassword:any) {
                return this.httpClient.post<any>(this.baseUrl + '/update_password.php', { email,password,cpassword })
                .pipe(map(Users => {
                return Users;
                }));
                }
            public verifyOtp(email: string, otp: number): Observable<any> {
              const body = { email, otp };
              return this.httpClient.post<any>(`${this.baseUrl}/verify_otp.php`, body);
            }

                public updateSA(mode:any,user_id:any,firstname:any,lastname:any,whatsapp_no:any,party_designation:any,email:any,approval_status:any,location_id='1',contact_no:any,profile_status:any) {
                console.log(profile_status);
                  const httpOptions : Object = {
                          headers: new HttpHeaders({
                            'Content-Type':'application/x-www-form-urlencoded'
                          })
                        };
                        console.log(user_id);
                    console.log("apidata : "+user_id,firstname,lastname,whatsapp_no,party_designation,approval_status)
                        return this.httpClient.post<any>(this.baseUrl + '/update.php?mode=0', {mode,user_id,firstname,lastname,whatsapp_no,party_designation,email,approval_status,location_id,contact_no,profile_status},httpOptions)
                                .pipe(map(Users => {                               
                                return Users;
                                }));
                          }

      public approve_role(user_id:any,new_role:any,status:any) {
        const httpOptions : Object = {
           headers: new HttpHeaders({
            'Content-Type':'application/x-www-form-urlencoded'
                 })
                            };
            return this.httpClient.post<any>(this.baseUrl + '/rolechange_app_rej.php', { user_id,new_role,status},httpOptions)
            .pipe(map(Users => {
              return Users;
                  }));
                              }

                                public create_meeting(meeting_name:any,meeting_date:any,meeting_time:any,participants:any,meeting_type:any,meeting_location:any, comments:any,meeting_district:any) {
                                return this.httpClient.post<any>(this.baseUrl + '/createmeeting.php',
                                { meeting_name,meeting_time,meeting_date,participants,meeting_type,meeting_location,comments,meeting_district},)
                                .pipe(map(Users => {
                                return Users;
                                }));
                                }

                                public rq_form(name:any,user_id:any,email:any,old_designation:any,new_designation:any,reason:any,district:any) {
                                  const httpOptions: Object = {
                                    headers: new HttpHeaders({
                                      'Content-Type': 'application/x-www-form-urlencoded'
                                    })
                                  };
                              
                                 return this.httpClient.post<any>(this.baseUrl + '/rolechange_req.php',
                                  {name,email,old_designation,district,new_designation,reason,user_id},httpOptions)
                                  .pipe(map(Users => {
                                  return Users;
                                  }));

                                }
                                public updateDA(mode:any,user_id:any,firstname:any,lastname:any,district:any,party_designation:any,email:any,whatsapp_no:any,approval_status:any,location_id:any,contact_no:any,fb_id:any,twitter_id:any,profile_status:any) {
                                 
                                  const httpOptions : Object = {
                                          headers: new HttpHeaders({
                                            'Content-Type':'application/x-www-form-urlencoded'
                                          })
                                        };
                                        console.log(user_id);
                                    console.log("apidata : "+user_id,firstname,lastname,district,party_designation,approval_status)
                                        return this.httpClient.post<any>(this.baseUrl + '/update.php?mode=1', {mode,user_id,firstname,lastname,district,party_designation,email,whatsapp_no,approval_status,location_id,contact_no,fb_id,twitter_id,profile_status},httpOptions)
                                                .pipe(map(Users => {
                                                return Users;
                                                }));
                                          }

public updateOB(datafull:FormData) {
  console.log(datafull);
        const httpOptions : Object = {
          headers: new HttpHeaders({
            'Content-Type':'application/x-www-form-urlencoded'
          })
        };
        const params = new HttpParams();

        const options = {
                params,
                reportProgress: true,
            };

   return this.httpClient.post<any>(this.baseUrl + '/update.php?mode=2', datafull,options)
                .pipe(map(Users => {
                  console.log(Users);
                return Users;
                }));
          }

                                                    tabledatameeting:any[]=[];
                                                    public viewtablemeeting() {
                                                   
                                                    return this.httpClient.get(this.baseUrl +'/tablemeeting.php');
                                                    }

  tableactivity: any[] = [];
  public viewTableActivity() {
    return this.httpClient.get(this.baseUrl + '/get_activity_index.php');
  }

public  viewOfficeBarriersActivity(district:any,constituency:any) {
  return this.httpClient.get(this.baseUrl + `/ob_get_activity.php?district=${district}&constituency=${constituency}`);
}

  public uploadActivityFile(data: any) {
    return this.httpClient.post(this.baseUrl + '/upload_activity_file.php', data);
  }

  public updateOBActivity(data: any) {
    return this.httpClient.post(this.baseUrl + '/create_ob_activity.php', data);
  }


  // Course Api service
  public getCourses() {
    return this.httpClient.get(this.baseUrl + '/get_courses.php');
  }

  public createCourses(data:any) {
    return this.httpClient.post(this.baseUrl + '/create_courses.php', data);
  }

  public deleteCourses(id:any) {
    return this.httpClient.get(this.baseUrl + `/delete_course.php?id=${id}`);
  }

   public updateCourses(id:any,data:any) {
    return this.httpClient.post(this.baseUrl + `/update_course.php?id=${id}`, data);
  }

  // Session Volunteer
  public getSessionVolunteer() {
    return this.httpClient.get(this.baseUrl + '/get_session_volunteer.php');
  }

   public getPiechartData() {
    return this.httpClient.get(this.baseUrl + '/get_pie_chart_count.php');
  }

    public getMentorData() {
    return this.httpClient.get(this.baseUrl + '/get_count_mentors_data.php');
  }

    public getStudentFeedbackList(district:any) {
    return this.httpClient.get(this.baseUrl + `/get_district_student_feedback.php?district=${district}`);
  }

   public getMentorFeedbackList(district:any) {
    return this.httpClient.get(this.baseUrl + `/get_district_mentor_feedback.php?district=${district}`);
  }

   public createMentorFeedback(values:any) {
    return this.httpClient.post(this.baseUrl + '/create_mentor_feedback.php', values);
  }

   public createStudentFeedback(values:any) {
    return this.httpClient.post(this.baseUrl + '/create_student_feedback.php', values);
  }

    public updateStudentFeedback(values:any) {
    return this.httpClient.post(this.baseUrl + '/update_student_feedback.php', values);
  }

   public updateMentorFeedback(values:any) {
    return this.httpClient.post(this.baseUrl + '/update_mentor_feedback.php', values);
  }


  public getSessionVolunteerForDistrict(district:any) {
    return this.httpClient.get(this.baseUrl + `/get_mentor_volunteer_session.php?district=${district}`);
  }

   public createSessionVolunteer(data:any) {
    return this.httpClient.post(this.baseUrl + '/create_session_volunteer.php', data);
  }

    public deleteSessionVolunteer(id:any) {
    return this.httpClient.get(this.baseUrl + `/delete_session_volunteer.php?id=${id}`);
  }

   public updateSessionVolunteer(id:any,data:any) {
    return this.httpClient.post(this.baseUrl + `/update_session_volunteer.php?id=${id}`, data);
  }


  // Course District Occurance

  public getDistrictOccurance() {
    return this.httpClient.get(this.baseUrl + '/get_district_occcurance.php');
  }
  public getDistrictOccurance_mentor() {
    return this.httpClient.get(this.baseUrl + '/get_dist_occurance_mentor.php');
  }
  public createDistrictOccurance(data:any) {
    return this.httpClient.post(this.baseUrl + '/create_district_occurance.php' ,  data);
  }

    public deleteDistrictOccurance(id:any) {
    return this.httpClient.get(this.baseUrl + `/delete_district_occurance.php?id=${id}`);
  }

   public updateDistrictOccurance(id:any,data:any) {
    return this.httpClient.post(this.baseUrl + `/update_district_occurance.php?id=${id}`, data);
  }

  public getOBDetailsForDistrictOccurance() {
    return this.httpClient.get(this.baseUrl + `/get_ob_district.php?district=${this.user_details.district}&constituency=${this.user_details.constituency}`);
  }


  // Student Registeration

  public getStudentsList(district:any=null) {
    return this.httpClient.get(this.baseUrl + `/get_students_list.php?district=${district}`);
  }

   public createStudentRegister(data:any) {
    return this.httpClient.post(this.baseUrl + '/create_student_register.php' ,  data);
  }

      public deleteStudentRegister(id:any) {
    return this.httpClient.get(this.baseUrl + `/delete_student_register.php?id=${id}`);
  }

     public updateStudentRegister(id:any,data:any) {
    return this.httpClient.post(this.baseUrl + `/update_student_register.php?id=${id}`, data);
  }

  // Course Assigned to Mentor

  public courseAssignedToMentor(id: any) {
    return this.httpClient.get(`${this.baseUrl}/get_mentorcourselist.php?id=${id}`);
    // return this.httpClient.get(this.baseUrl + `/get_mentorcourselist.php?first_name=${firstname}`);
  }

  // Mentor

   public getMentorsList(district:any=null) {
    return this.httpClient.get(this.baseUrl + `/get_mentors.php?district=${district}`);
  }

    public createMentor(data:any) {
    return this.httpClient.post(this.baseUrl + '/create_mentor.php' ,  data);
  }

        public deleteMentor(id:any) {
    return this.httpClient.get(this.baseUrl + `/delete_mentor.php?id=${id}`);
  }

      public updateMentor(id:any,data:any) {
    return this.httpClient.post(this.baseUrl + `/update_mentor.php?id=${id}`,data);
  }

           public deletemeeting(id:any) {
              const httpOptions : Object = {
                headers: new HttpHeaders({
                  'Content-Type':'application/x-www-form-urlencoded'
                })
              };
                return this.httpClient.post<any>(this.baseUrl + '/deletemeeting.php', { id},httpOptions)
                .pipe(map(Users => {
                return Users;
                }));
  }

  public deleteActivity(id: any) {
    const httpOptions: Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    return this.httpClient.post<any>(this.baseUrl + '/delete_activity.php', { id }, httpOptions);
  }


  public updateActivity(id: any, form: any) {

    return this.httpClient.post<any>(this.baseUrl + `/update_activity.php?id=${id}`,form);
  }

  public summaryActivity(id: any) {
    return this.httpClient.get(this.baseUrl + `/summary_activity.php?id=${id}`);
  }

                public updatemeeting(id:any,meeting_date:any,meeting_time:any) {
                  console.log(id,meeting_date,meeting_time)
                  const httpOptions : Object = {
                          headers: new HttpHeaders({
                            'Content-Type':'application/x-www-form-urlencoded'
                          })
                        };
                  return this.httpClient.post<any>(this.baseUrl + '/updatemeeting.php', {id,meeting_date,meeting_time},httpOptions)
                                .pipe(map(Users => {
                                return Users;
                                }));
                          }
                          public request_post_request(postrequest="Pending") {
                            return this.httpClient.post<any>(this.baseUrl + 'add_post_request.php', { postrequest })
                            .pipe(map(Users => {
                            return Users;
                            }));
                            }
                            public dacreate_meeting(meeting_name:any,meeting_date:any,meeting_time:any,participants:any,meeting_type:any,meeting_location:any, comments:any,meeting_district:any) {
                            return this.httpClient.post<any>(this.baseUrl + '/dacreatemeeting.php',
                            { meeting_name,meeting_time,meeting_date,participants,meeting_type,meeting_location,comments,meeting_district},)
                            .pipe(map(Users => {
                            return Users;
                            }));
                            }
                            tabledatablemeeting:any[]=[];
                            public datablemeeting(district) {
                              const httpOptions : Object = {
                                headers: new HttpHeaders({
                                  'Content-Type':'application/x-www-form-urlencoded'
                                })
                              };
                              return this.httpClient.post<any>(this.baseUrl + '/dameeting_show.php', {district},httpOptions)
                              .pipe(map(Users => {
                              return Users;
                              }));

                                                      }

                                                  public daupdate_meeting(id:any,meeting_date:any,meeting_time:any) {
                                                    console.log(id,meeting_date,meeting_time)
                                                    const httpOptions : Object = {
                                                            headers: new HttpHeaders({
                                                              'Content-Type':'application/x-www-form-urlencoded'
                                                            })
                                                          };
                                                    return this.httpClient.post<any>(this.baseUrl + '/daupdate_meeting.php', {id,meeting_date,meeting_time},httpOptions)
                                                                  .pipe(map(Users => {
                                                                  return Users;
                                                                  }));
                                                                }

public addtionalPostRequest(id:any,name:any,district:any,applied_posting:any,applied_role:any){
      const httpOptions : Object = {
      headers: new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
      })
      };
            return this.httpClient.post<any>(this.baseUrl + '/add_reqform.php', {id,name,district,applied_posting,applied_role},httpOptions)
            .pipe(map(Users => {
            return Users;
            }));
}
public dropdown(district:any) {
  return this.httpClient.post(this.baseUrl+"/enggdropdown.php",{district})
}
public addtionalPostReqApproval() {
      return this.httpClient.get(this.baseUrl +'/da_addtional-post-show.php');
}
public Add_RoleApproval(da_id:any,status:any) {
 const httpOptions : Object = {
      headers: new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
       })  };
  return this.httpClient.post<any>(this.baseUrl + '/da_addtional_role_app_rej.php', {da_id, status},httpOptions)
  .pipe(map(Users => {
    return Users;
        }));
                    }
public AddRole_Button(district:any) {
    const httpOptions : Object = {
    headers: new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded'
    })  };
      return this.httpClient.post<any>(this.baseUrl + '/da_addtional-post-button.php', {district},httpOptions)
      .pipe(map(Users => {
        return Users;
            }));
  }

//To get image of user by id
public getImage(id:string){
  const httpOptions : Object = {
    headers: new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded'
     })  };

     return this.httpClient.post<any>(this.baseUrl + '/photopreview.php', {id},httpOptions)

}



//token
setToken(token: string) {
  localStorage.setItem('token', token);
  }
  getToken() {
    this.user_details = JSON.parse(localStorage.getItem('login_user_details'));
  return localStorage.getItem('token');
  }
  deleteToken() {
  localStorage.removeItem('token');
  }
  isLoggedIn() {
  const usertoken = this.getToken();
  if (usertoken != null) {
  return true
  }
  return false;
  }
public checkpassword(id:any,password:any,cpassword:any) {
                return this.httpClient.post<any>(this.baseUrl + '/update_check_password.php', {id, password,cpassword })
                .pipe(map(Users => {
                return Users;
                }));
                }
                // selfupdatebyda
public updateddaSelf(datafull:FormData): Observable<any> {
  console.log('ddd');
  console.log(datafull);
        const httpOptions : Object = {
          headers: new HttpHeaders({
            'Content-Type':'application/x-www-form-urlencoded'
          })
        };
        const params = new HttpParams();

        const options = {
                params,
                reportProgress: true,
            };

   return this.httpClient.post<any>(this.baseUrl + '/selfupdatebyda.php', datafull,options)
                .pipe(map(Users => {
                  console.log(Users);
                return Users;
                }));
          }
          table_report_ob:any[] = [];
          public report_ob(district: any){
            return this.httpClient.post(this.baseUrl + '/ob-report.php',{district});
          }

          public profile(id: any){
            return this.httpClient.post(this.baseUrl + '/profile.php',{id});
          }


          public da_addressreport(){
            return this.httpClient.get(this.baseUrl+'/da-addressreport.php?mode=1');
          }
          table_zone_report:any[] = [];
          public zone_report(district: any){
            console.log(district);
            return this.httpClient.post(this.baseUrl + '/zone-report.php',{district});
          }

          public winner_list(datafull:FormData) {
            const httpOptions : Object = {
              headers: new HttpHeaders({
                'Content-Type':'application/x-www-form-urlencoded'
              })
            };

          const params = new HttpParams();

          const options = {
                params,
                reportProgress: true,
            };

            datafull.forEach((value,key) => {
              console.log(key+" "+value)
              });

            return this.httpClient.post<any>(this.baseUrl + '/winner_list.php',datafull,options)
            .pipe(map(Users => {
            return Users;
            }));
            }
            // district_check_winner
          public  district_check_winner(constituency: any){

            return this.httpClient.post(this.baseUrl + '/winner_district_check.php',{constituency});
          }
          public  district_check_winner_list_show(constituency: any){

            return this.httpClient.post(this.baseUrl + '/winner_list_show.php',{constituency});
          }

          approveMentor(id: any, approve: any) {
            const url = `${this.baseUrl}/Approve_mentor.php`; // Replace 'approve-mentor' with your actual endpoint
            const data = {
              id: id,
              approve: approve
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Set headers if needed
            const headers = {
              'Content-Type': 'application/json'
            };
        
            return this.httpClient.post(url, jsonData, { headers: headers });
          }

          deleteStudent(id: number) {
            const url = `${this.baseUrl}/student_delete.php`; 
            const data = {
              id: id,
    
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Define headers if necessary
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              })
            };
        
            // Pass the student ID as a parameter in the request body
            return this.httpClient.post(url, jsonData, httpOptions);
          }
          signOutStudent(id: number) {
            const url = `${this.baseUrl}/signout.php`; 
            const data = {
              id: id,
    
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Define headers if necessary
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              })
            };
        
            // Pass the student ID as a parameter in the request body
            return this.httpClient.post(url, jsonData, httpOptions);
          }
          signOutMentor(id: number) {
            const url = `${this.baseUrl}/signout-mentor.php`; 
            const data = {
              id: id,
    
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Define headers if necessary
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              })
            };
        
            // Pass the student ID as a parameter in the request body
            return this.httpClient.post(url, jsonData, httpOptions);
          }
          deletedMenter(id: number) {
            const url = `${this.baseUrl}/mentor_delete.php`; 
            const data = {
              id: id,
    
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Define headers if necessary
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              })
            };
        
            // Pass the student ID as a parameter in the request body
            return this.httpClient.post(url, jsonData, httpOptions);
          }
          public getImage1(id:string){
            const httpOptions : Object = {
              headers: new HttpHeaders({
              'Content-Type':'application/x-www-form-urlencoded'
               })  };
        
               return this.httpClient.post<any>(this.baseUrl + '/job_seeker_img.php', {id},httpOptions)
        
          }

          
          forstdId(id: number) {
            const url = `${this.baseUrl}/mentorNameIden.php`; 
            const data = {
              id: id,
    
            }; // Data to be sent in the request body
        
            // Convert data to JSON string
            const jsonData = JSON.stringify(data);
        
            // Define headers if necessary
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              })
            };
        
            // Pass the student ID as a parameter in the request body
            return this.httpClient.post(url, jsonData, httpOptions);
          }
          public mentorFeedbackcheck(values:any) {
            return this.httpClient.post(this.baseUrl + '/mentor_feedback_check.php', values);
          }
          public studentFeedbackcheck(values:any) {
            return this.httpClient.post(this.baseUrl + '/student_feedback_check.php', values);
          }

          public createMentorcourse(values:any) {
            return this.httpClient.post(this.baseUrl + '/mentorcourse.php', values);
          }
          public createMentorcourserequest(values:any) {
            return this.httpClient.post(this.baseUrl + '/request_course.php', values);
          }
            // get_courese_byId
            public get_courese_byuserId(id: any) {
              return this.httpClient.get(`${this.baseUrl}/get_mentorcourselist.php?id=${id}`);
            } 
            public get_all_courese() {
              return this.httpClient.get(this.baseUrl + '/sa-approved-course.php');
            }              
            public approved_coure(values: any) {
              return this.httpClient.post(this.baseUrl + '/sa-approved-course.php', values);
            }
            public rejectCourse(values: any) {
              return this.httpClient.post(this.baseUrl + '/sa-approved-course.php', values);
            }
                    
            // get_coursebyid
            public get_coursebyid(id: any) {
              return this.httpClient.get(`${this.baseUrl}/get_coursebyId.php?id=${id}`);
            }
           public updateMentorcourse(values: any) {
            console.log(values);
            return this.httpClient.put(`${this.baseUrl}/updatecourse_by_id.php`, values);
           }

           getAllCourses(): Observable<any[]> {
            return this.httpClient.get<any[]>(this.baseUrl+ `/mentor_student_course.php`);
          }



          public studentEnrolledMentorCourse(values:any) {
            return this.httpClient.post(this.baseUrl + '/student_enroll_mentor_course.php', values);
          }

         public getEnrolledCourses(student_id: number,permanent_token:any) {
            const payload = { student_id: student_id,
              permanent_token: permanent_token  
             };
            return this.httpClient.post<any>(this.baseUrl + '/get_student_enrolled_courses.php', payload);
          }
          public unenrollCourse(unenrollmentData: any) {
            return this.httpClient.post(this.baseUrl + '/unenroll_course.php', unenrollmentData);
          }
         public getCoursesAndStudentsByMentor(mentorId: number): Observable<any> {
            return this.httpClient.get<any>(this.baseUrl+ `/student_enroll_list.php?mentor_id=${mentorId}`);
          }


          //merge code

public createVolunteer(values:any) {
  return this.httpClient.post(this.baseUrl + '/CreateVolunteer.php', values);
}
public getVolunteer(mentor_id:any) {
  return this.httpClient.get(this.baseUrl + '/GetVolunteerMentor.php?mentor_id='+mentor_id);
}
public updateVolunteer(values:any) {
  return this.httpClient.post(this.baseUrl + '/UpdateVolunteerMentor.php', values);
}
public deleteVolunteer(id:any) {
  return this.httpClient.get(this.baseUrl + '/DeleteVolunteerMentor.php?id='+id);
}
public daGetVolunteerList(user_id:any) {
  return this.httpClient.get(this.baseUrl + '/DA_GetMentorVolunteer.php?user_id='+user_id);
}
public mentor_dashboard(id: any,token:string) {
  const headers = new HttpHeaders({
    'Authorization': token
  });
  return this.httpClient.get(`${this.baseUrl}/mentor_dashboard.php?id=${id}`,{headers});
}

submitStudentFeedback(feedbackData: any) {
  return this.httpClient.post<any>(this.baseUrl + '/add_mentor_feedback.php', feedbackData);
}

public studentEnrolledCourse(id: any) {
  return this.httpClient.get(`${this.baseUrl}/get_enrolled_course.php?id=${id}`);
  // return this.httpClient.get(this.baseUrl + `/get_mentorcourselist.php?first_name=${firstname}`);
}
        }
